import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {authLoader} from '../../loader';
import {ROUTE_PHARMA_ACTIVITY_PLANNING_REPORT} from '@app/navigations/RoutePathConstant';

const PharmaActivityPlanningReport = lazy(() =>
  import('../../../screens/PharmaActivityPlanningReport')
    .then(module => ({default: module.PharmaActivityPlanningReport})));

const PharmaActivityPlanningReportNavigation = [
  {
    path: ROUTE_PHARMA_ACTIVITY_PLANNING_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <PharmaActivityPlanningReport />
      </Suspense>
    ),
  },
];

export default PharmaActivityPlanningReportNavigation;
